import React, { type ReactElement } from 'react';
import classNames from 'classnames';

import Setting from '@/common/components/setting';

import HamburgerIcon from '~/public/assets/images/svg/hamburger.svg';

interface Props {
  iconClassName?: string;
}

export default function Hamburger({ iconClassName }: Props): ReactElement {
  return (
    <Setting
      id="store-click-menu-v1"
      className="flex h-10 w-10 items-center justify-center"
    >
      <HamburgerIcon
        className={classNames('h-5 w-5 text-black-default', iconClassName)}
      />
    </Setting>
  );
}
